<template>
  <div>
    <filter-header/>
    <v-container grid-list-md>
      <date-filter />
      <!--deposit-date /-->
      </br>
      <others />
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { EventBus } from '@/services/event-bus';

export default {
  name: 'Filters',
  components: {
    FilterHeader: () => import('./Header.vue'),
    DateFilter: () => import('./DateFilter.vue'),
    Others: () => import('./Others.vue'),
  },
};

</script>